import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get baseDocRule
export const getBaseDocRule = createAsyncThunk("baseDocRule/getBaseDocRule", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getBaseDocRule({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all baseDocRule
export const getAllBaseDocRule = createAsyncThunk("baseDocRule/getAllBaseDocRule", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllBaseDocRule();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("baseDocRule/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("baseDocRule/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "baseDocRule/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageBaseDocRule({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get particular page
export const getBaseDocRuleById = createAsyncThunk(
  "baseDocRule/getBaseDocRuleById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getBaseDocRuleById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create baseDocRule
export const createBaseDocRule = createAsyncThunk(
  "baseDocRule/createBaseDocRule",
  async (
    param,

    { rejectWithValue }
  ) => {
    try {
      const {
        poRequiredForGrn,
        grnRequiredForGrnAdditional,
        poRequiredForPi,
        grnRequiredForPi,
        piRequiredForPore,
        soRequiredForDn,
        dnRequiredForSi,
        soRequiredForSi,
        siRequiredForSore,
      } = param;

      const body = JSON.stringify({
        poRequiredForGrn,
        grnRequiredForGrnAdditional,
        poRequiredForPi,
        grnRequiredForPi,
        piRequiredForPore,
        soRequiredForDn,
        dnRequiredForSi,
        soRequiredForSi,
        siRequiredForSore,
      });

      const { data } = await API.createBaseDocRule(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateBaseDocRule = createAsyncThunk(
  "baseDocRule/updateBaseDocRule",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;

    const {
      poRequiredForGrn,
      grnRequiredForGrnAdditional,
      poRequiredForPi,
      grnRequiredForPi,
      piRequiredForPore,
      soRequiredForDn,
      dnRequiredForSi,
      soRequiredForSi,
      siRequiredForSore,
    } = values;
    try {
      const body = JSON.stringify({
        poRequiredForGrn,
        grnRequiredForGrnAdditional,
        poRequiredForPi,
        grnRequiredForPi,
        piRequiredForPore,
        soRequiredForDn,
        dnRequiredForSi,
        soRequiredForSi,
        siRequiredForSore,
      });
      const { data } = await API.updateBaseDocRule(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("baseDocRule/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
